<template>
    <div v-if="predefinedRemark != undefined">
        <b-col sm="3" class="mx-0 px-0 my-1 py-0">
            <label>{{ prefRemarkLabel }}:</label>
        </b-col>

        <b-col sm="9" class="mx-0 px-0 my-1 py-0">
            <!-- Time input for ADATA_IQ_PHVP -->
            <b-form-input
                v-if="predefinedRemark.iq === iqPHVP"
                type="time"
                v-model="predefinedRemark.regtijd"
                :disabled="!editAllowed"
            ></b-form-input>

            <!-- Text input for another type -->
            <!-- b-form-input
                v-else-if="
                    predefinedRemark && predefinedRemark.iq === someOtherType
                "
                type="text"
                v-model="predefinedRemark.someTextProperty"
                :disabled="!editAllowed"
            ></b-form-input -->

            <!-- Number input for yet another type -->
            <!-- b-form-input
                v-else-if="
                    predefinedRemark && predefinedRemark.iq === anotherType
                "
                type="number"
                v-model.number="predefinedRemark.someNumberProperty"
                :disabled="!editAllowed"
            ></b-form-input -->

            <!-- Default input if none of the above match -->
            <b-form-input
                v-else
                type="time"
                v-model="predefinedRemark.regtijd"
                :disabled="!editAllowed"
            ></b-form-input>
        </b-col>
    </div>
</template>

<script>
import DateHelper from '@/models/DateHelper';
import PredefRemarkHelper from '@/models/PredefRemarkHelper';
export default {
    name: 'PredefinedHelper',
    data() {
        return {
            prefRemarkLabel: '',
            predefinedRemark: null,
            predefinedType: null,
            iqPHVP: window.constants.ADATA_IQ_PHVP
        };
    },
    model: {
        prop: 'visible',
        event: 'changed'
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        inObject: {
            type: Object,
            required: false
        },
        predefinedObject: {
            type: Object,
            required: false
        },
        iq: {
            type: Number,
            required: false
        },
        editAllowed: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        iq: {
            handler: function (newVal, oldVal) {
                if (oldVal && oldVal > -1) {
                    const o = { iq: newVal };
                    this.initiateSpecRemark(o);
                }
            }
        }
    },
    computed: {},
    methods: {
        initiateSpecRemark(remarkObject) {
            const returnObject = PredefRemarkHelper.initiateSpecRemark(
                remarkObject, this.$t
            );
            if (returnObject == undefined) {
                return null;
            }
            if (returnObject.type != undefined) {                
                this.predefinedRemark = returnObject.remark;
                this.prefRemarkLabel = returnObject.label;
                this.predefinedType = returnObject.type;
                this.$emit('changed', returnObject);
            }
            return returnObject;
        }

    },
    mounted() {},
    created() {
        // als predefinedObject dan gaat die voor
        const pref = PredefRemarkHelper.setSpecRemark(this.predefinedObject,this.$t);
        if (pref == undefined) {
            const test = this.initiateSpecRemark(this.inObject);
            if (test == undefined) {
                const o = { iq: this.iq };
                this.initiateSpecRemark(o);
            } 
        } else {
            this.predefinedRemark = pref.remark;
            this.prefRemarkLabel = pref.label;
            this.predefinedType = pref.type;
        }
    }
};
</script>

<style scoped></style>
